import { useMutation } from '@tanstack/react-query';

import { queryKeys } from '@app/hooks';
import { makeRequest } from '@app/utils';

export const useAccountActivation = () => {
  return useMutation([queryKeys.accountActivation], (token: string) =>
    makeRequest({
      url: '/opac-users/activate-user-by-registration-link',
      method: 'POST',
      data: {
        verificationToken: token,
      },
    })
  );
};
